import fb from '../images/socials/fb.svg'
import insta from '../images/socials/insta.svg'
import twitter from '../images/socials/twitter.svg'
import tiktok from '../images/socials/tiktok.svg'
import email from '../images/socials/email.svg'

import styled from 'styled-components'
import { mediaQueries } from '../shared/config';
import Background from '../images/bottom_flowers.png';


const Container = styled.div`
  background: url(${Background});
  position: relative;
	height: 88.5em;
  width: 100%;
	color: white;
	padding: 60px 0 10px 0;
    text-align: center;
	h1 {
		margin: 0;
		font-family: 'Times New Roman', Times, serif;
    font-size: 30px;
	}
  /* margin-bottom: 20px; */
  
`



const Socials = styled.div`
  position: relative;
  margin-top: 20px;

  img {

    position: relative;
    margin: 0 20px;
  }
  p {
    position: relative;
    margin: 80px 20px;
    color: white;
    

    ${mediaQueries.mobile} {
      margin: 50px 20px;
    }
  }
`

const Content = styled.div`
  position: relative;
  top: 85%;
  bottom: 5%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
`

const Footer = () => {
    return (
      <Container>
        <Content>
        <h1>DAILY BRUIN</h1>
        <Socials>
          <a href="https://www.instagram.com/dailybruin" target="_blank"><img src={insta}/></a>
          <a href="https://www.facebook.com/dailybruin" target="_blank"><img src={fb}/></a>
          <a href="https://www.twitter.com/dailybruin" target="_blank"><img src={twitter}/></a>
          <a href="https://www.tiktok.com/@dailybruin" target="_blank"><img src={tiktok}/></a>
          <a href="http://eepurl.com/cFEiZX" target="_blank"><img src={email}/></a>
          <p>Built with Suzy’s ♥ in Kerckhoff 118 by Annie Tran, Donny Rimer, Ed Nawrocki, Hameed Shaik, Katherine Li, Maria Martins, Marvin Deng, Michelle Kim, Nicole Ju, Richelle Shim, Sakshi Thoutireddy, Yifan Tang, Yubo Zhang. Designed by Lindsey Murto and Helen Quach.</p>
        </Socials>
        </Content>
    </Container>
    
    )
  }
  
export default Footer;